import {
  NavBarBody,
  NavBarFooterProfile,
  NavProvider,
} from '@airship-platform/airship-patterns';
import { Outlet } from 'react-router';

const App: React.FC = () => (
  <NavProvider navbarBody={<NavBarBody />} footerNode={<NavBarFooterProfile />}>
    <Outlet />
  </NavProvider>
);

export default App;
